import React, { useState, useEffect, AlertTrianglefrom } from "react";
import axios from "axios";
import {
  AlertTriangle,
  Clock,
  CheckCircle,
  FileText,
  Download,
  CheckSquare,
  XCircle,
  LogOut,
} from "lucide-react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

const Echeances = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [echeances, setEcheances] = useState([]); // liste dynamique
  const [loading, setLoading] = useState(true); // indicateur de chargement
  const [error, setError] = useState(null); // gestion d'erreur
  const [selectedEcheance, setSelectedEcheance] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [clientInfo, setClientInfo] = useState(null);
  const [markingId, setMarkingId] = useState(null);

  // Fonction de déconnexion
  const handleLogout = () => {
    localStorage.removeItem('client_token');
    localStorage.removeItem('client_info');
    window.location.href = '/connexion';
  };

  // Fonction pour récupérer les infos du client
  const getClientInfo = () => {
    try {
      const clientInfoString = localStorage.getItem("client_info");
      if (clientInfoString) {
        return JSON.parse(clientInfoString);
      }
      return null;
    } catch (error) {
      console.error("Erreur lors du parsing des informations client:", error);
      return null;
    }
  };

  //  Chargement des données depuis Laravel au montage du composant
  useEffect(() => {
    // Charger les infos du client
    const loadedClientInfo = getClientInfo();
    setClientInfo(loadedClientInfo);
    const fetchEcheances = async () => {
      try {
        // ✅ Récupérer le token stocké
        const token = localStorage.getItem("client_token");


        if (!token) {
          console.error("Aucun token trouvé, utilisateur non connecté");
          setError("Vous devez être connecté pour voir vos échéances");
          setLoading(false);
          return;
        }

        const response = await axios.get(
          "https://api-ec.cinef-expertises.com/api/client/echeances",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );


        console.log("Échéances :", response.data);

        setEcheances(response.data.data);
        setLoading(false);
      } catch (err) {
        console.error("Erreur chargement échéances :", err);
        setError("Impossible de charger les échéances.");
        setLoading(false);
      }
    };

    fetchEcheances();
  }, []);

  // ✅ AJOUT : Fonction pour marquer une échéance comme traitée ou passée
  const handleMarquerStatut = async (id, nouveauStatut) => {
    try {
      setMarkingId(id);
      const token = localStorage.getItem("client_token");

      await axios.patch(
        `https://api-ec.cinef-expertises.com/api/client/echeances/${id}/statut`,
        { statut: nouveauStatut },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Mise à jour locale sans recharger toute la liste
      setEcheances((prev) =>
        prev.map((e) =>
          e.id === id ? { ...e, statut: nouveauStatut } : e
        )
      );

      // Si le modal est ouvert sur cette échéance, mettre à jour aussi
      if (selectedEcheance && selectedEcheance.id === id) {
        setSelectedEcheance((prev) => ({ ...prev, statut: nouveauStatut }));
      }

      setMarkingId(null);
    } catch (err) {
      console.error("Erreur mise à jour statut :", err);
      alert("Impossible de mettre à jour le statut.");
      setMarkingId(null);
    }
  };

  const getStatutStyle = (statut) => {
    switch (statut) {
      case "urgent":
        return "urgent";
      case "a_venir":
        return "a_venir";
      case "planifie":
        return "planifie";
      // ✅ AJOUT : nouveaux statuts
      case "traite":
        return "traite";
      case "passe":
        return "passe";
      default:
        return "";
    }
  };

  const getStatutIcon = (statut) => {
    switch (statut) {
      case "urgent":
        return <AlertTriangle size={16} className="status-icon urgent" />;
      case "a_venir":
        return <Clock size={16} className="status-icon a_venir" />;
      case "planifie":
        return <CheckCircle size={16} className="status-icon planifie" />;
      // ✅ AJOUT : icônes pour les nouveaux statuts
      case "traite":
        return <CheckSquare size={16} className="status-icon traite" />;
      case "passe":
        return <XCircle size={16} className="status-icon passe" />;
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const calculateDaysRemaining = (dateEcheance) => {
    const today = new Date();
    const echeance = new Date(dateEcheance);
    const diffTime = echeance - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };


  const handleVoirDetails = (echeance) => {
    setSelectedEcheance(echeance);
    setShowModal(true);
  };

// 📥 Fonction de téléchargement sécurisé via l'API
  const handleTelechargerFichier = async (echeanceId, titre) => {
    if (!echeanceId) {
      alert("Aucun fichier disponible pour cette échéance");
      return;
    }

    try {
      const token = localStorage.getItem("client_token");
      
      if (!token) {
        alert("Vous devez être connecté pour télécharger un fichier");
        return;
      }

      // Appel à la route API sécurisée
      const response = await fetch(
        `https://api-ec.cinef-expertises.com/api/client/echeances/${echeanceId}/download`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
          }
        }
      );

      if (response.ok) {
        // Récupérer le fichier comme blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        // Créer un lien de téléchargement
        const link = document.createElement("a");
        link.href = url;
        link.download = titre || "document.pdf";
        
        // Télécharger le fichier
        document.body.appendChild(link);
        link.click();
        
        // Nettoyer
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        const data = await response.json();
        alert(data.message || "Erreur lors du téléchargement du fichier");
      }
    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
      alert("Impossible de télécharger le fichier. Veuillez réessayer.");
    }
  };



  return (
    <>
      <div className="app-container">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <div className="main-wrapper">
          <Navbar onMenuToggle={() => setIsSidebarOpen(!isSidebarOpen)} />

          <main className="main-content">
            <div className="page-header">
              <div className="header-content">
                <div className="header-text">
                  <h1 className="page-title">Échéances Fiscales</h1>
                  <p className="page-subtitle">
                    Suivez toutes vos obligations fiscales et leurs échéances
                  </p>
                </div>
              </div>
            </div>

            {/* Gestion du chargement */}
            {loading && <p>Chargement des échéances...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}

            {/* Affichage des stats si les données existent */}
            {!loading && !error && (
              <>
                <div className="stats-grid">
                  <div className="stat-card urgent">
                    <h3>Urgentes</h3>
                    <p>
                      {echeances.filter((e) => e.statut === "urgent").length}
                    </p>
                  </div>

                  <div className="stat-card a_venir">
                    <h3>À venir</h3>
                    <p>
                      {echeances.filter((e) => e.statut === "a_venir").length}
                    </p>
                  </div>

                  <div className="stat-card planifie">
                    <h3>Planifiées</h3>
                    <p>
                      {echeances.filter((e) => e.statut === "planifie").length}
                    </p>
                  </div>

                  {/* ✅ AJOUT : Cartes stats pour les nouveaux statuts */}
                  <div className="stat-card traite">
                    <h3>Traitées</h3>
                    <p>
                      {echeances.filter((e) => e.statut === "traite").length}
                    </p>
                  </div>

                  <div className="stat-card passe">
                    <h3>Passées</h3>
                    <p>
                      {echeances.filter((e) => e.statut === "passe").length}
                    </p>
                  </div>
                </div>

                {/* Liste des échéances */}
                <div className="echeances-container">
                  <div className="container-header">
                    <h2>Liste des échéances</h2>
                  </div>

                  {echeances.length === 0 ? (
                    <p style={{ padding: "20px" }}>
                      Aucune échéance enregistrée.
                    </p>
                  ) : (
                    <div className="echeances-list">
                      {echeances.map((echeance) => (
                        <div
                          key={echeance.id}
                          className={`echeance-item ${echeance.statut === "traite" || echeance.statut === "passe"
                              ? "echeance-item--done"
                              : ""
                            }`}
                        >
                          <div className="echeance-content">
                            <div className="echeance-main">
                              {getStatutIcon(echeance.statut)}
                              <div className="echeance-info">
                                <h4>{echeance.titre}</h4>
                                <p>{echeance.description}</p>
                                <span>
                                  Échéance :{" "}
                                  {formatDate(echeance.date_echeance)}
                                </span>
                                <span>
                                  (
                                  {calculateDaysRemaining(
                                    echeance.date_echeance
                                  )}{" "}
                                  jours restants)
                                </span>
                              </div>
                            </div>

                            <div className="echeance-actions">
                              <p className="echeance-amount">
                                {parseFloat(
                                  echeance.montant || 0
                                ).toLocaleString("fr-FR")}{" "}
                                XOF
                              </p>
                              <span
                                className={`status-badge ${getStatutStyle(
                                  echeance.statut
                                )}`}
                              >
                                {echeance.statut?.toUpperCase()}
                              </span>
                              <div className="action-buttons">
                                <button
                                  className="btn-action primary"
                                  onClick={() => handleVoirDetails(echeance)}
                                >
                                  <FileText size={14} />
                                  Voir détails
                                </button>

                                {/* Afficher le bouton Télécharger seulement s'il y a un fichier */}
                                {echeance.url_fichier && (
                                  <button
                                    className="btn-action secondary"
                                    onClick={() => handleTelechargerFichier(echeance.id, echeance.titre)}
                                  >
                                    <Download size={14} />
                                    Télécharger
                                  </button>
                                )}

                                {/* ✅ AJOUT : Boutons de marquage selon le statut actuel */}
                                {echeance.statut !== "traite" && echeance.statut !== "passe" && (
                                  <>
                                    <button
                                      className="btn-action mark-traite"
                                      disabled={markingId === echeance.id}
                                      onClick={() =>
                                        handleMarquerStatut(echeance.id, "traite")
                                      }
                                    >
                                      <CheckSquare size={14} />
                                      {markingId === echeance.id ? "..." : "Veuillez payer"}
                                    </button>
                                    <button
                                      className="btn-action mark-passe"
                                      disabled={markingId === echeance.id}
                                      onClick={() =>
                                        handleMarquerStatut(echeance.id, "passe")
                                      }
                                    >
                                      <XCircle size={14} />
                                      {markingId === echeance.id ? "..." : "Marquer passée"}
                                    </button>
                                  </>
                                )}

                                {/* ✅ AJOUT : Bouton pour réinitialiser si passée (mais pas si traitée) */}
                                {echeance.statut === "passe" && (
                                  <button
                                    className="btn-action reset"
                                    disabled={markingId === echeance.id}
                                    onClick={() =>
                                      handleMarquerStatut(echeance.id, "planifie")
                                    }
                                  >
                                    <Clock size={14} />
                                    {markingId === echeance.id ? "..." : "Réinitialiser"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Modal Voir Détails */}
            {showModal && selectedEcheance && (
              <div
                className="modal-overlay"
                onClick={() => setShowModal(false)}
              >
                <div
                  className="modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-header">
                    <h2>Détails de l'échéance</h2>
                    <button
                      className="modal-close"
                      onClick={() => setShowModal(false)}
                    >
                      ×
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="detail-row">
                      <span className="detail-label">Titre:</span>
                      <span className="detail-value">
                        {selectedEcheance.titre}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Description:</span>
                      <span className="detail-value">
                        {selectedEcheance.description}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Date d'échéance:</span>
                      <span className="detail-value">
                        {formatDate(selectedEcheance.date_echeance)}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Montant:</span>
                      <span className="detail-value">
                        {parseFloat(
                          selectedEcheance.montant || 0
                        ).toLocaleString("fr-FR")}{" "}
                        XOF
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Statut:</span>
                      <span
                        className={`status-badge ${getStatutStyle(
                          selectedEcheance.statut
                        )}`}
                      >
                        {selectedEcheance.statut?.toUpperCase()}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Jours restants:</span>
                      <span className="detail-value">
                        {calculateDaysRemaining(selectedEcheance.date_echeance)}{" "}
                        jours
                      </span>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn-action secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Fermer
                    </button>

                    {/* Afficher le bouton Télécharger seulement s'il y a un fichier */}
                    {selectedEcheance.url_fichier && (
                      <button
                        className="btn-action primary"
                        onClick={() => handleTelechargerFichier(selectedEcheance.id, selectedEcheance.titre)}
                      >
                        <Download size={14} />
                        Télécharger
                      </button>
                    )}

                    {/* ✅ AJOUT : Boutons de marquage dans le modal */}
                    {selectedEcheance.statut !== "traite" && selectedEcheance.statut !== "passe" && (
                      <>
                        <button
                          className="btn-action mark-traite"
                          disabled={markingId === selectedEcheance.id}
                          onClick={() => handleMarquerStatut(selectedEcheance.id, "traite")}
                        >
                          <CheckSquare size={14} />
                          {markingId === selectedEcheance.id ? "..." : "Marquer traitée"}
                        </button>
                        <button
                          className="btn-action mark-passe"
                          disabled={markingId === selectedEcheance.id}
                          onClick={() => handleMarquerStatut(selectedEcheance.id, "passe")}
                        >
                          <XCircle size={14} />
                          {markingId === selectedEcheance.id ? "..." : "Marquer passée"}
                        </button>
                      </>
                    )}

                    {/* ✅ AJOUT : Réinitialiser dans le modal (uniquement si passée, pas si traitée) */}
                    {selectedEcheance.statut === "passe" && (
                      <button
                        className="btn-action reset"
                        disabled={markingId === selectedEcheance.id}
                        onClick={() => handleMarquerStatut(selectedEcheance.id, "planifie")}
                      >
                        <Clock size={14} />
                        {markingId === selectedEcheance.id ? "..." : "Réinitialiser"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .app-container {
          display: flex;
          height: 100vh;
          background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .main-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          margin-left: 320px;
        }

        .main-content {
          flex: 1;
          padding: 32px;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
        }

        .main-content::-webkit-scrollbar {
          width: 6px;
        }

        .main-content::-webkit-scrollbar-track {
          background: transparent;
        }

        .main-content::-webkit-scrollbar-thumb {
          background: rgba(0, 138, 68, 0.2);
          border-radius: 10px;
        }

        /* Header Section */
        .page-header {
          margin-bottom: 40px;
        }

        .header-content {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .header-icon {
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          flex-shrink: 0;
        }

        .header-text {
          flex: 1;
        }

        .page-title {
          font-size: 32px;
          font-weight: 700;
          margin: 0 0 6px 0;
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .page-subtitle {
          color: #64748b;
          margin: 0;
          font-size: 16px;
          font-weight: 500;
        }

        /* Stats Grid */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 24px;
          margin-bottom: 40px;
        }

        .stat-card {
          background: #ffffff;
          padding: 28px;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: currentColor;
        }

        .stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
        }

        .stat-card.urgent {
          color: #dc3545;
        }

        .stat-card.a_venir {
          color: #f59e0b;
        }

        .stat-card.planifie {
          color: #10b981;
        }

        /* ✅ AJOUT : Couleurs des nouvelles cartes stats */
        .stat-card.traite {
          color: #3b82f6;
        }

        .stat-card.passe {
          color: #8b5cf6;
        }

        .stat-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .stat-info {
          flex: 1;
        }

        .stat-title {
          font-size: 16px;
          font-weight: 600;
          color: currentColor;
          margin: 0 0 12px 0;
          opacity: 0.9;
        }

        .stat-value {
          font-size: 36px;
          font-weight: 700;
          color: currentColor;
          margin: 0;
          line-height: 1;
        }

        .stat-icon {
          opacity: 0.8;
          color: currentColor;
        }

        /* Echeances Container */
        .echeances-container {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.05);
          overflow: hidden;
          margin-bottom: 40px;
        }

        .container-header {
          padding: 24px 28px;
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(0, 138, 68, 0.05) 100%);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .container-title {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          letter-spacing: -0.3px;
        }

        .echeances-list {
          padding: 0;
        }

        .echeance-item {
          padding: 24px 28px;
          border-bottom: 1px solid #f1f5f9;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .echeance-item:last-child {
          border-bottom: none;
        }

        .echeance-item:hover {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        /* ✅ AJOUT : Style visuel pour les échéances traitées/passées */
        .echeance-item--done {
          opacity: 0.65;
          background: #f8fafc;
        }

        .echeance-item--done:hover {
          opacity: 0.85;
        }

        .echeance-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
        }

        .echeance-main {
          display: flex;
          align-items: flex-start;
          gap: 16px;
          flex: 1;
          min-width: 0;
        }

        .status-icon {
          margin-top: 2px;
          flex-shrink: 0;
        }

        .status-icon.urgent {
          color: #dc3545;
        }

        .status-icon.a_venir{
          color: #f59e0b;
        }

        .status-icon.planifie {
          color: #10b981;
        }

        /* ✅ AJOUT : Couleurs icônes nouveaux statuts */
        .status-icon.traite {
          color: #3b82f6;
        }

        .status-icon.passe {
          color: #8b5cf6;
        }

        .echeance-info {
          flex: 1;
          min-width: 0;
        }

        .echeance-title {
          font-size: 17px;
          font-weight: 600;
          color: #1e293b;
          margin: 0 0 6px 0;
          line-height: 1.3;
        }

        .echeance-details {
          font-size: 14px;
          color: #64748b;
          margin: 0 0 12px 0;
          line-height: 1.4;
        }

        .echeance-meta {
          display: flex;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
        }

        .echeance-date {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
        }

        .echeance-days {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
        }

        .echeance-actions {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-shrink: 0;
        }

        .echeance-amount-section {
          text-align: right;
        }

        .echeance-amount {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 8px 0;
        }

        .status-badge {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .status-badge.urgent {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: #ffffff;
        }

        .status-badge.a_venir {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          color: #ffffff;
        }

        .status-badge.planifie {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
        }

        /* ✅ AJOUT : Badges pour les nouveaux statuts */
        .status-badge.traite {
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          color: #ffffff;
        }

        .status-badge.passe {
          background: linear-gradient(135deg, #8b5cf6, #7c3aed);
          color: #ffffff;
        }

        .action-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .btn-action {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          border: none;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: inherit;
        }

        .btn-action:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none !important;
          box-shadow: none !important;
        }

        .btn-action.primary {
          background: linear-gradient(135deg, #10b981, #059669);
          color: #ffffff;
        }

        .btn-action.primary:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }

        .btn-action.secondary {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: #ffffff;
        }

        .btn-action.secondary:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
        }

        /* ✅ AJOUT : Styles boutons nouveaux statuts */
        .btn-action.mark-traite {
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          color: #ffffff;
        }

        .btn-action.mark-traite:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        }

        .btn-action.mark-passe {
          background: linear-gradient(135deg, #8b5cf6, #7c3aed);
          color: #ffffff;
        }

        .btn-action.mark-passe:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
        }

        .btn-action.reset {
          background: linear-gradient(135deg, #64748b, #475569);
          color: #ffffff;
        }

        .btn-action.reset:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(100, 116, 139, 0.3);
        }

        /* Quick Actions */
        .quick-actions {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .btn-primary {
          padding: 14px 28px;
          background: linear-gradient(135deg, #dc3545, #008A44);
          color: #ffffff;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
          letter-spacing: -0.2px;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(220, 53, 69, 0.3);
        }

        .btn-secondary {
          padding: 14px 28px;
          background: #ffffff;
          color: #1e293b;
          border: 2px solid #10b981;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
          letter-spacing: -0.2px;
        }

        .btn-secondary:hover {
          background: #10b981;
          color: #ffffff;
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .modal-content {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 600px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          animation: modalSlideIn 0.3s ease-out;
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .modal-header {
          padding: 24px 28px;
          border-bottom: 1px solid #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(0, 138, 68, 0.05) 100%);
        }

        .modal-header h2 {
          margin: 0;
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          background: linear-gradient(135deg, #dc3545, #008A44);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .modal-close {
          background: none;
          border: none;
          font-size: 32px;
          color: #64748b;
          cursor: pointer;
          line-height: 1;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .modal-close:hover {
          background: #f1f5f9;
          color: #1e293b;
        }

        .modal-body {
          padding: 28px;
        }

        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .detail-row:last-child {
          border-bottom: none;
        }

        .detail-label {
          font-weight: 600;
          color: #64748b;
          font-size: 14px;
        }

        .detail-value {
          font-weight: 600;
          color: #1e293b;
          font-size: 15px;
          text-align: right;
        }

        .modal-footer {
          padding: 20px 28px;
          border-top: 1px solid #f1f5f9;
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          flex-wrap: wrap;
          background: #f8fafc;
        }

        /* Responsive Design */
        @media (max-width: 1023px) {
          .main-wrapper {
            margin-left: 0;
          }

          .main-content {
            padding: 20px;
          }

          .page-title {
            font-size: 28px;
          }

          .stats-grid {
            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
            gap: 16px;
          }

          .stat-card {
            padding: 20px;
          }
        }

        @media (max-width: 768px) {
          .main-content {
            padding: 16px;
          }

          .header-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }

          .page-title {
            font-size: 24px;
          }

          .echeance-content {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
          }

          .echeance-actions {
            flex-direction: column;
            gap: 12px;
          }

          .echeance-amount-section {
            text-align: left;
          }

          .action-buttons {
            flex-direction: column;
          }

          .btn-action {
            justify-content: center;
          }

          .quick-actions {
            flex-direction: column;
          }

          .btn-primary,
          .btn-secondary {
            width: 100%;
          }
        }

        @media (max-width: 480px) {
          .stats-grid {
            grid-template-columns: 1fr 1fr;
          }

          .echeances-container {
            border-radius: 12px;
          }

          .container-header,
          .echeance-item {
            padding: 20px;
          }

          .echeance-meta {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }
        }
      `}</style>
    </>
  );
};

export default Echeances;